import Checkpoint from "./checkpoint";
import {resolveOperatorByName} from "./checkpoint-operator-definitions";
import {ListElementBuilder, getFilterLabelMap, sanitizeHtml} from "./util";
import { delayCheckpoint } from "./index";
import resource from "@core/Util/resources";

export default class FilterCheckpoint extends Checkpoint {
    constructor() {
        super('filter', 'JourneyBuilder_Checkpoint_Filter', 'JourneyBuilder_Checkpoint_Filter_Description', { iconClass: 'fas fa-map-signs' });
    }

    get defaultOrder() {
        return 4;
    }

    buildTooltip(connection) {
        const config = this.readForConnection(connection);

        const tooltipContent = new Promise(async resolve => {
            if(!config || !config.conditions) {
                return undefined;
            }

            const filterLabelMap = await getFilterLabelMap();
            let content = '';

            config.conditions.forEach(group => {
                const builder = new ListElementBuilder();
                group.forEach(
                    condition => builder.add(`${filterLabelMap.get(condition.field)} ${resolveOperatorByName(condition.operator).label} ${filterLabelMap.get(condition.value)}`)
                );
                content += builder;
            });

            resolve(content);
        });

        return {
            title: 'Filter checkpoint',
            content: tooltipContent
        }
    }
    
    buildInteractionFiltersWithoutDelayMessage(connectionOrConnections) {
        const INTERACTION_FILTER_FIELDS = ['EMevent'];
        const NO_MESSAGE = '';
        
        //Ensure we have an enumerable set of connections - our tooltip is build for either an individual connection
        //or for a popover to be displayed upon saving our journey
        const connections = Array.isArray(connectionOrConnections) ? 
            connectionOrConnections :
            [connectionOrConnections];
        
        const eligibleConnections = connections.filter(
            connection => this.isActiveForConnection(connection) &&
                          this.readForConnection(connection).conditions &&
                          this.readForConnection(connection).conditions.length &&
                          !delayCheckpoint.isActiveForConnection(connection)
        );
        
        //https://datanext.atlassian.net/browse/DPN-3563
        //So called 'interaction' filters require a delay checkpoint to be defined prior to actually being able to take effect
        if(!eligibleConnections.length) {
            return NO_MESSAGE;
        }

        const eligibleConditions = eligibleConnections
            //For all eligible connections - take their condition groups stored in the conditions field
            //this will result in an array consisting of arrays
            //[[ { field: ... } ], [ { field: ... } ], [ { field: ... } ]]
            .map(connection => this.readForConnection(connection).conditions)
            //Flatten our array of arrays by 2 levels
            //this will yield the following structure
            //[ { field: ... }, { field: ... }, { field: ... } ]
            .flat(2);
        
        //Create a set containing only unique field names for easy filtering
        const uniqueFields = new Set(
            eligibleConditions.map(condition => condition.field)
        );
        
        const interactionFieldsWithoutDelay = INTERACTION_FILTER_FIELDS
            .filter(field => uniqueFields.has(field));
        
        if(!interactionFieldsWithoutDelay.length) {
            return NO_MESSAGE;
        }
        
        return sprintf(
            resource('JourneyBuilder_FilterSettings_InteractionFilter_NoDelayCheckpoint_ConfirmationBody'),
            interactionFieldsWithoutDelay.map(field => sanitizeHtml(field)).join(', ')
        );
    }
}